module.exports = __webpack_public_path__ + "img/01.2deb38e5.png";